export const checkWageRateType = (value: number | string) => {
  if (typeof value === 'number') {
    return value;
  }
  const convertStringIntoDouble = parseFloat(value);
  return convertStringIntoDouble;
};
